import FormItem from "@/entities/PrizificPageBuilder/components/FormItem";
import { EComponents } from "@/enums/PrizificPageBuilder/EComponents";
import { ECodeUploadFormItem } from "~/enums/PrizificPageBuilder/ECodeUploadFormItem";

export const howToPurchseFormItem = new FormItem(
    "-",
    "How to purchase form item",
    [],
    "",
    [],
    "Hogyan vásároltál?",
    "",
    "Hogyan vásároltál?",
    "",
    ECodeUploadFormItem.HOW_TO_PURCHASE
);
